export default "__VITE_ASSET__BXnqKVU$__"